module.exports = __webpack_public_path__ + "img/ic-close-small-white.b57d63ee.svg";